import { render, staticRenderFns } from "./contextmenuCollect.vue?vue&type=template&id=04fee062&scoped=true&"
import script from "./contextmenuCollect.vue?vue&type=script&lang=js&"
export * from "./contextmenuCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fee062",
  null
  
)

export default component.exports